import { AppState } from "../store";
import { CampaignUrl, EditCampaignUrl, DashboardUrl, ReportUrl } from "../../common";

const urls = [CampaignUrl, EditCampaignUrl, DashboardUrl, ReportUrl];

export function currentClientId(_appState: AppState): string | undefined {
    return urls
        .map(u => u.match(window.location, false))
        .filter(u => u.isMatched)
        .map(u => (u.isMatched ? u.params.clientId : undefined))[0];
}
